import { IApiService } from '../services/api_service';

export const auth = (siteApi: IApiService) => ({
  postToken: (username: string, password: string) => {
    return siteApi.post('/auth/token', {
      username,
      password,
      grant_type: 'password',
      client_id: 'relcore-site'
    });
  },
  password: {
    put: (currentPassword: string, newPassword: string) => {
      return siteApi.put('/auth/password', {
        currentPassword,
        newPassword
      });
    }
  }
});
